// @ts-nocheck

// hash must look like this: #o=4239842&b=32992384&test=value382
export const extrudePropertiesFromHash = (hash: string) => {
  const res = {};

  if (hash?.length && hash.charAt(0) === '#') {
    const base = hash.substr(1);
    const assignments = base.split('&');

    for (const assignment of assignments) {
      const [key, value] = assignment.split('=');

      if (key !== undefined && key !== null) {
        res[key] = value;
      }
    }
  }

  return res;
};
